// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"1f7fc376","242":"abd2ed82"}[chunkId] + ".chunk.js";
};